const features = [
  {
    icon: 'ri-arrow-down-double-line',
    title: '下拉式流畅阅读',
    desc: '独创下拉式阅读模式，一滑到底无缝加载，无需频繁翻页打断阅读节奏，给你从头到尾一气呵成的沉浸式漫画体验。',
  },
  {
    icon: 'ri-book-open-line',
    title: '海量全集免费看',
    desc: '收录最新韩漫、热门国漫、经典日漫全集资源，全部免费开放阅读，无需付费订阅即可畅享海量正版优质漫画内容。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '实时追更不等待',
    desc: '热门连载漫画每日准点同步更新，第一时间追到最新剧情。支持收藏追更提醒，再也不会错过任何一话更新。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              平台特色
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              布丁漫画下拉式阅读，重新定义你的漫画观看方式
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {features.map((item, i) => (
              <div
                key={i}
                className="group p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}